import Collection from '../collection';

export default Collection.extend( {
    responseAt: 'photos'
} );


// WEBPACK FOOTER //
// ./src/js/collection/photos.js